// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1___e03a847de6b3d65f420","cls2":"CreateSocialItem-cls2___669c523fc15adb3105a CreateSocialItem-cls1___e03a847de6b3d65f420"};